import {useState} from "react";
import useMerchantPortalAxios, {useMerchantPortalFormData} from "../utils/axios";

const ExternalTransferAPI = () => {
    const MerchantPortalAxios = useMerchantPortalAxios();
    const MerchantPortalAxios1 = useMerchantPortalFormData();
    const [transferData, setTransferData] = useState([]);
    const [totalNbOfPage, setTotalNbOfPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [bankTransfersLoading, setBankTransfersLoading] = useState(true);

    async function GetBankDepositOrders(pageNb, dateFrom, DateTo, type) {
        await MerchantPortalAxios.post(
            `/v1/ExternalTransfer/GetBankDepositOrders`,
            {
                SessionID: sessionStorage.getItem("SessionID"),
                page: pageNb,
                pageSize: 10,
                DateFrom: dateFrom,
                DateTo: DateTo,
                OrderType: type
            }
        ).then((res) => {
            setTransferData(res.data.Payload.BankDepositOrders);
            if (res.data.Payload?.BankDepositOrders?.length===0){
                setTotalNbOfPage(0);
                setTotalCount(0);
            }else{
                setTotalNbOfPage(res.data.Payload.BankDepositOrders[0].TotalPages);
                setTotalCount(res.data.Payload.BankDepositOrders[0].TotalCount);
            }

            setBankTransfersLoading(false);

            if (res.data.Payload?.TemplateURL)
                sessionStorage.setItem("BankTransferTemplate", res.data.Payload.TemplateURL);
        });
    }

    const NewBankDepositRequest = async (payload) => {
        if (payload.ProofOfPayment) {
            const fileData = payload.ProofOfPayment.split(',')[1];
            const mimeType = payload.ProofOfPayment.split(':')[1].split(';')[0];
            const byteCharacters = atob(fileData);
            const byteArrays = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteArrays[i] = byteCharacters.charCodeAt(i);
            }
            payload.ProofOfPayment = new File([byteArrays], payload.ReasonFileName, {type: mimeType});
        }

        const response = await MerchantPortalAxios1.post('/v1/ExternalTransfer/NewBankDepositRequest', payload);
        const body = response?.data;
        const normalizedPayload = body?.Payload;

        if (normalizedPayload && typeof normalizedPayload === "object") {
            return {
                ...normalizedPayload,
                data: body
            };
        }

        return body;

    };

    return {
        GetBankDepositOrders,
        NewBankDepositRequest,
        transferData,
        totalNbOfPage,
        totalCount,
        bankTransfersLoading
    };
};

export default ExternalTransferAPI;
